<template>
  <div>
    <span v-if="bankDetails">
      {{ $t('bankDetails.bankName') }} {{ bankDetails.bank_name }}
      <br />
      {{ $t('bankDetails.bankAddress') }}
      {{ bankDetails.bank_address.join(', ') }}
      <br />
      <span v-if="bankDetails.swift">
        {{ $t('bankDetails.swift') }} {{ bankDetails.swift }}
        <br />
      </span>
      <span v-if="bankDetails.aba_routing">
        {{ $t('bankDetails.abaRouting') }} {{ bankDetails.aba_routing }}
        <br />
      </span>
      <span v-if="bankDetails.ac_name">
        {{ $t('bankDetails.accName') }} {{ bankDetails.ac_name }}
        <br />
      </span>
      <span v-if="bankDetails.ac_no">
        {{ $t('bankDetails.accNumber') }} {{ bankDetails.ac_no }}
        <br />
      </span>
      <span v-if="bankDetails.bank_sort_code">
        {{ $t('bankDetails.bankSort') }} {{ bankDetails.bank_sort_code }}
        <br />
      </span>
      <span v-if="bankDetails.iban">
        {{ $t('bankDetails.iban') }} {{ bankDetails.iban }}
        <br />
      </span>

      <span v-if="bankDetails.beneficiary">
        <span v-if="bankDetails.beneficiary.bank_name">
          {{ $t('bankDetails.benName') }}
          {{ bankDetails.beneficiary.bank_name }}
          <br />
        </span>
        <span v-if="bankDetails.beneficiary.bank_address">
          {{ $t('bankDetails.benAddress') }}
          {{ bankDetails.beneficiary.bank_address }}
          <br />
        </span>
        <span v-if="bankDetails.beneficiary.swift">
          {{ $t('bankDetails.benSwift') }} {{ bankDetails.beneficiary.swift }}
          <br />
        </span>
        <span v-if="bankDetails.beneficiary.ac_name">
          {{ $t('bankDetails.benAccount') }}
          {{ bankDetails.beneficiary.ac_name }}
          <br />
        </span>
        <span v-if="bankDetails.beneficiary.ac_no"
          >{{ $t('bankDetails.benAccNum') }}
          {{ bankDetails.beneficiary.ac_no }}</span
        >
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: ['bankDetails']
}
</script>
